import { defineMessages } from 'react-intl';

export default defineMessages({
  returnCarriersHeading: {
    description: 'Activation Modal > Carrier Setup > Heading',
    defaultMessage: 'Set Default Return Service',
    id: 'XsXqwH',
  },
  returnCarriersDescription: {
    description: 'Activation Modal > Carrier Setup > Description',
    defaultMessage: 'Choose which service to automatically apply to all return labels.',
    id: 'qbEurd',
  },
  cheapestOptionLabel: {
    description: 'Activation Modal > Carrier Setup > Cheapest Option Label',
    defaultMessage: 'Cheapest',
    id: 'GqiZ24',
  },
  cheapestOptionDescription: {
    description: 'Activation Modal > Carrier Setup > Cheapest Option Description',
    defaultMessage: 'By default, ShipStation selects the cheapest available service for your return labels.',
    id: 'zYsV/S',
  },
  preferredServiceLabel: {
    description: 'Activation Modal > Carrier Setup > Preferred Service Label',
    defaultMessage: 'Use my preferred service',
    id: 'pZK/eU',
  },
  preferredServiceDescription: {
    description: 'Activation Modal > Carrier Setup > Preferred Service Description',
    defaultMessage: 'Designate your preferred service to be used for all return labels.',
    id: 'Hi8a6R',
  },
  carrierDropdownLabel: {
    description: 'Activation Modal > Carrier Setup > Carrier Dropdown Label',
    defaultMessage: 'Carrier',
    id: 'N+f1g6',
  },
  serviceDropdownLabel: {
    description: 'Activation Modal > Carrier Setup > Service Dropdown Label',
    defaultMessage: 'Service',
    id: 'eNPo3N',
  },
  selectCarrierPlaceholder: {
    description: 'Activation Modal > Carrier Setup > Select Carrier Placeholder',
    defaultMessage: 'Select Carrier',
    id: '/HdtGs',
  },
  selectServicePlaceholder: {
    description: 'Activation Modal > Carrier Setup > Select Service Placeholder',
    defaultMessage: 'Select Service',
    id: 'DxG2Tt',
  },
  continueButton: {
    description: 'Activation Modal > Carrier Setup > Continue Button',
    defaultMessage: 'Continue',
    id: 'b7262u',
  },
  cancelButton: {
    description: 'Activation Modal > Carrier Setup > Cancel Button',
    defaultMessage: 'Cancel',
    id: 'NXJwTP',
  },
  returnCarrierSelectionFailureMessage: {
    description: 'Activation Modal > Carrier Setup > Error Message',
    defaultMessage: 'Failed to select return services. Please try again.',
    id: 'uUfsrb',
  },
  fetchCarriersFailureMessage: {
    description: 'Activation Modal > Carrier Setup > Fetch Carriers Error Message',
    defaultMessage: 'Failed to load services. Please try again.',
    id: 'tcVRyD',
  },
  loadingServicesText: {
    description: 'Activation Modal > Carrier Setup > Loading Services Text',
    defaultMessage: 'Loading services...',
    id: 'vUdH3z',
  },
});
